import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Colour-only green theme for customer & vendor pages; Admin Panel is excluded.
export default function GreenTheme() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.body.classList.toggle("vb-green-theme", !pathname.startsWith("/admin"));
  }, [pathname]);
  return null;
}
